module.exports = __webpack_public_path__ + "fe81267573a23bbf9a660bfade124bc1.svg";